import styled from "styled-components";

const SummaryTabWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  h4{
    color: black;
  }


  .title-card {
    background-color: white;
  }

  h1 {
    font-size: clamp(36px, 5vw, 72px);
    font-weight: 600;
  }
  h2 {
    font-size: clamp(32px, 4vw, 44px);
    font-weight: 600;
  }

  h3 {
    font-size: 22px;
    font-weight: 600;
  }

  li::marker {
    color: #fbb03b;
    font-size: 22px;
  }

  .text-golden {
    color: #df9900;
  }

  .nav-link.active {
    color: black;
    font-weight: 600;
  }

  &::-webkit-slider-thumb {
    background: green !important;
  }

  &::-moz-range-thumb {
    background: green !important;
  }

  p {
    font-size: 16px;
  }

  table {
    background-color: white;
    font-size: 16px;
  }
  thead {
    background-color: #ececec;
    font-size: 18px;
  }

  /* th div {
    font-size: 16px !important;
  } */
  td,
  th {
    padding: 1rem !important;
    text-align: start !important;
    vertical-align: middle !important;
  }

  td.p-0{
    padding: 0 !important;
    border: none !important;
  }
  .table-sector {
    background-color: gainsboro;
    font-weight: bold;
  }

  .table-total {
    background-color: black;
    color: white;
    font-weight: bold;
  }

  .table-section {
    width: 100%;
    background-color: rgb(253, 245, 232);
  }

  .type-switch {
    font-size: 20px;
  }

  @media screen and (max-width: 576px) {
    .type-switch {
      font-size: 14px;
    }
  }

  select,
  select:focus {
    background-color: transparent;
    border: 1px solid green;
    color: green;
    width: 100%;
    font-size: 14px;
  }

  .c-dark-theme & {
    background-color: #181924;

    .title-card {
      background-color: #34343b !important;
    }

    table {
      border: 1.5px solid #ffffff;
    }

    .table-sector {
      background-color: var(--clr-table-dark-2) !important;
    }

    .table-total {
      background-color: var(--clr-table-dark-1) !important;
    }

    th {
      background-color: var(--clr-table-header-dark);
    }

    tr {
      background-color: transparent !important;
    }

    .table-section {
      background-color: #24252f;
    }

    /* input {
      color: #ffffff !important;
    } */
    select {
      color: #ffffff;
    }

    .react-select__single-value {
      color: #ffffff;
    }
  }

  h1 {
    color: var(--warning);
    font-weight: 700;
    font-size: 5em;
  }

  h2 {
    color: var(--success);
    font-weight: 600;
    font-size: 3em;
  }

  .circle-text{
    color: var(--success);
    font-weight: 600;
    font-size: 1.5em;
    text-align: center;

  }

  table {
    background-color: white;
    font-size: 16px;
  }
  thead {
    background-color: #ececec;
    font-size: 18px;
  }
  .table-sector {
    background-color: gainsboro;
    font-weight: bold;
    font-size: 18px!important;
    p {
      font-size: 18px!important
    }
  }

  li {
    text-align: left;
  }

  

  .table-question.row-0,.table.area-0 tr.p-0 {
      background-color: #00924517!important;

      
  }
  .table-question.row-1,.table.area-1 tr.p-0 {
    background-color: #FFDF0717!important;

  }
  .table-question.row-2,.table.area-2 tr.p-0 {
      background-color: #A421D117!important;
      
  }
  .table-question.row-3,.table.area-3 tr.p-0 {
      background-color: #487db217!important; 
  }


  .table-sector.row-0 {
    
    background-color: #00924582!important;
  }
  .table-sector.row-1 {
    background-color: #FFDF0782!important;
      
  }
  .table-sector.row-2 {
      background-color: #A421D182!important;
      
  }
  .table-sector.row-3 {
      background-color: #487db282!important; 
  }

  .table.area-0 thead{
    background-color: #009245!important;
  }

  .table.area-1 thead{
    background-color: #d9bd00!important;
  }

  .table.area-2 thead{
    background-color: #A421D1!important;
  }

  .table.area-3 thead{
    background-color: #487db2!important;
  }

  .table[class*="area-"] thead{
    color: white !important;}

  @media screen and (max-width: 766px) {
    padding-block: 0;
    /* padding-inline: 0.5rem; */

    .mobile-d-none {
      display: none;
    }
  }
`;

export default SummaryTabWrapper;
